import { render, staticRenderFns } from "./VDashboardBankAccount.vue?vue&type=template&id=06917726&"
import script from "./VDashboardBankAccount.vue?vue&type=script&lang=js&"
export * from "./VDashboardBankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports